<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ 'Doc::VATComputation' | abpLocalization }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="mb-3">
    <p>
      {{
        'Doc::Doc:VatSystemContraintsNotRespected'
          | abpLocalization: (vatSystemId() | displayName: coreEnumerationTypeStore.vatSystems())
      }}
    </p>
    <p>
      {{ 'Doc::UpdateIncompliantVatCodesQuestion' | abpLocalization }}
    </p>
  </div>
  <form [formGroup]="form">
    <div class="row">
      <div class="col d-flex align-items-end">
        <input
          class="me-2 form-check-input"
          type="checkbox"
          role="switch"
          id="evaluateArticlePrices"
          formControlName="evaluateArticlePrices"
        />
        <label for="evaluateArticlePrices" class="form-label text-primary">
          {{ 'Doc::ReevaluateTariff' | abpLocalization }}
        </label>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary ms-2" (click)="modal.close()">
    {{ 'ERP::Cancel' | abpLocalization }}
  </button>
  <button class="btn btn-primary ms-2" (click)="confirm()">
    {{ 'GoliathCore::Yes' | abpLocalization }}
  </button>
</div>
